import React from 'react';
import t from 'prop-types';

var EntradaTipoUnidad = function EntradaTipoUnidad(_ref) {
  var numUnidad = _ref.numUnidad,
      bullet = _ref.bullet,
      titulo = _ref.titulo,
      seleccionada = _ref.seleccionada,
      lecciones = _ref.lecciones,
      onClick = _ref.onClick;
  return React.createElement('div', {
    className: "unidadIndice" + numUnidad + (lecciones && seleccionada ? " activa" : ""),
    onClick: onClick
  },
  /*numUnidad &&*/
  bullet !== false && React.createElement('div', {
    className: 'bullet'
  }), React.createElement('span', {
    dangerouslySetInnerHTML: {
      __html: titulo
    }
  }));
};

EntradaTipoUnidad.propTypes = process.env.NODE_ENV !== "production" ? {
  numUnidad: t.oneOfType([t.string, t.number]),
  bullet: t.bool,
  titulo: t.string,
  seleccionada: t.bool,
  lecciones: t.array,
  onClick: t.func
} : {};
export default EntradaTipoUnidad;